module.exports = __webpack_public_path__ + "img/hr-concrete.6681529c.png";